/**
 * @param target an object whose value is the base of the operation
 * @param source and object whose value will be added to target
 * @return deep merged object containing values from both target and source. target values would be overwritten if same prop name is found on source
 */
export function mergeDeep(target, source) {
    if (typeof target === 'object' && typeof source === 'object') {
        Object.keys(source).forEach(key => {
            if (source[key] === null && (target[key] === undefined || target[key] === null)) {
                target[key] = null;
            } else if (source[key] instanceof Array) {
                if (!target[key]) {
                    target[key] = [];
                }
                target[key] = target[key].concat(source[key]);
            } else if (typeof source[key] === 'object') {
                if (!target[key]) {
                    target[key] = {};
                }
                mergeDeep(target[key], source[key]);
            } else {
                target[key] = source[key];
            }
        });
    }
    return target;
}
